import { useSelector } from 'react-redux';

import { useLibraryPermissions } from '~/components/LibraryBeta/hooks/useLibraryPermissions';
import { useCurrentBoardPermissions } from '~/hooks/useCurrentBoardPermissions';
import { useURLLibraryIdSelector } from '~/hooks/useURLLibraryIdSelector';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { CentralizedBoardSelectors, centralizedBoardLibraryIdSelector } from '~/store/centralizedBoard/selectors';
import { canCreateCanvasInCurrentLocation } from '~/utils/permissions/canCreateCanvasInCurrentLocation';

export const useCanCreateCanvasInCurrentLocation = () => {
  const boardId = useSelector(CentralizedBoardSelectors.boardId);
  const boardLibraryId = useSelector(centralizedBoardLibraryIdSelector);
  const urlLibraryId = useURLLibraryIdSelector();
  const libraryId = boardLibraryId ?? urlLibraryId;
  const { boardPermissions } = useCurrentBoardPermissions();
  const { libraryPermissions } = useLibraryPermissions({ libraryId });
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();

  return {
    canCreateCanvas: canCreateCanvasInCurrentLocation({
      boardId,
      boardPermissions,
      libraryId,
      libraryPermissions,
      workspacePermissions,
    }),
  };
};
